import React from 'react';
import styles from 'components/layout_and_quote_builder/_style.module.scss';

const LoadingOverlay = ({ message }) => {
  const displayMessage = message || 'Loading';

  return (
    <div className={styles.progressOverlay}>
      <div className={styles.progressCard}>
        <div className={styles.progressTitle}>
          {displayMessage}
        </div>

        <div className={styles.loadingSpinnerContainer}>
          <img
            src="https://d2atdwxjx7uc4i.cloudfront.net/images/bx_loader.gif"
            width="40px"
            alt="Loading"
          />
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
